// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__3wemB","buttonContainer":"Image_buttonContainer__3ZyjJ","actionButton":"Image_actionButton__ksrSo"};